
const Printer = (element) => {
  const articleContent = element.outerHTML;
  const printButtons = document.querySelectorAll(".do-print");

  const openPrintDialog = () => {
    const printWindow = window.open('', '', 'width=1280,height=700');

    const version = new Date().getTime();

    const cssUrls = [
      `${window.location.origin}/wp-content/themes/bespoke-theme/assets/vendor/bootstrap/bootstrap.min.css?v=${version}`,
      `${window.location.origin}/wp-content/themes/bespoke-theme/assets/vendor/fontawesome/css/all.min.css?v=${version}`,
      `${window.location.origin}/wp-content/themes/bespoke-theme/assets/css/main.css?v=${version}`,
      `${window.location.origin}/wp-content/themes/bespoke-theme/dist/css/bundle.css?v=${version}`
    ];

    const cssLinks = cssUrls.map(url => `<link rel="stylesheet" type="text/css" href="${url}">`).join('\n');

    const printDocument = `
      <html>
      <head>
        <title>Print Article</title>
        ${cssLinks}
        <style>
          html,
          body {
            background: white !important;
          }

          .intersection-active {
            opacity: 1 !important;
            transform: translate3d(0, 0, 0) !important;
          }

          .mainArticle,
          .mainArticle__contentContainer {
            background: white !important;
            color: black !important;
          }

          .mainArticle__heroContainer {
            padding-top: 80px !important;
          }

          .mainArticle__metadata__share,
          .mainArticle__back,
          .mainArticle__prev,
          .mainArticle__share,
          .mainArticle__mobilenav, 
          .mainArticle__next,
          .authorCard__text .socialButton {
            display: none !important;
          }

          .print-only {
            display: block !important;
          }

          .mainArticle__content {
            h1,
            h2,
            h3,
            h4,
            h5,
            h6,
            p,
            figcaption,
            ul li,
            ol li {
              color: black !important;
            }
          }
        </style>
      </head>
      <body>
        ${articleContent}
      </body>
      </html>
    `;

    printWindow.document.write(printDocument);
    printWindow.document.close();
    printWindow.focus();
  };

  const addEventListeners = () => {
    if (printButtons?.[0]) {
      printButtons.forEach(printButton => {
        printButton.addEventListener("click", openPrintDialog);
      });
    }
  };

  const main = () => {
    addEventListeners();
  };

  main();
};

export default Printer;
